export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./chart-rtp.vue?vue&type=template&id=31f871b3"


//////////////////
// WEBPACK FOOTER
// ./src/components/stats/chart-rtp.vue?vue&type=template&id=31f871b3
// module id = LGD/
// module chunks = 0